// Must stay in sync with `PasswordValidationServiceImpl` in us-services
export const passwordMinLength = 8;
export const passwordSpecialCharacterRegex = String.raw`[^A-Za-z0-9]`;
export const validPasswordRegex = String.raw`^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*${passwordSpecialCharacterRegex}).{${passwordMinLength},}$`;

export const passwordStrengthTypes = [
  'empty',
  'weak',
  'medium',
  'good',
  'strong',
] as const;

export const passwordFailureKeys = [
  'tooShort',
  'noLower',
  'noUpper',
  'noDigit',
  'noSymbol',
] as const;

export type PasswordStrengthType = typeof passwordStrengthTypes[number];

export type PasswordFailureKey = typeof passwordFailureKeys[number];

export interface PasswordStrength {
  value: number;
  type: PasswordStrengthType;
}
